import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-right-navbar',
  imports: [RouterLink],
  templateUrl: './right-navbar.component.html',
  styleUrl: './right-navbar.component.css'
})
export class RightNavbarComponent {

}
